import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface ICompanyGroupEditItem extends IEditItem {
    code: string;
    name: string;
    comment: string;
    modifyUser: IModifyUser;
}

export class CompanyGroupEditItem extends EditItem implements ICompanyGroupEditItem {
    code: string;
    name: string;
    comment: string;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: ICompanyGroupEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}